import React, { useState } from "react";
import './ViewallButton.css';

const ViewallButton = ({ onClick }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const handleClick = () => {
        const callBackVriableIsExpanded = !isExpanded; // This variable is used to pass the value of isExpanded back to the parent component which uses this component.

        setIsExpanded(!isExpanded);

        if (onClick) {
            onClick(callBackVriableIsExpanded);
        }
    };

    return (
        <div className="viewall-button__container" onClick={handleClick}>
            <button className={`viewall-button ${isExpanded ? 'expanded' : ''}`}></button>
            <div className="viewall-context">
                <p>{isExpanded ? "View Less" : "View All"}</p>
            </div>
        </div>
    );
};

export default ViewallButton;